class ProductCrossSelling {
    constructor() {
        this.productOtherElement = document.querySelector('.product-cross-selling');
        if (this.productOtherElement) {
            this.initSwiper();
        }
    }

    initSwiper() {
        this.swiper = new Swiper('.carousel-cross-selling', {
            slidesPerView: 1.5,
            spaceBetween: 10,
            freeMode: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 10,
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                }
            }
        });
    }


}

// Inizializza la classe solo se l'elemento è presente
new ProductCrossSelling();